import React from "react";
import styled from "styled-components";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import { lightTheme } from "@themes/Theme";

const UserPresenceWrapper = styled.div`
    height: inherit;
    width: auto;
    max-width: 120px;
    overflow-x: scroll;

    padding: 1px 4px;
`;

const NumParticipantsPill = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    height: 30px;
    min-width: 30px;
    width: fit-content;

    padding: 0 10px;
    border-radius: 15px;
    background-color: ${Styles.userAviColors.blue};
    color: ${lightTheme.textColorPrimary};
    font-size: ${FontSize.normal};

    cursor: pointer;
`;

interface UserRoomPresenceListProps {
    readonly numGuests: number;
    readonly isMembersModalOpen: boolean;
    readonly setIsMembersModalOpen: (isOpen: boolean) => void;
}

function UserRoomPresenceList(props: UserRoomPresenceListProps) {
    return (
        <UserPresenceWrapper>
            <NumParticipantsPill>{props.numGuests.toLocaleString()}</NumParticipantsPill>
        </UserPresenceWrapper>
    );
}

export default UserRoomPresenceList;
